import React, { useState, useEffect } from 'react';
import {
    Box, Button, Flex, FormControl, FormLabel, Input, Table, Tbody, Td, Th, Thead, Tr, VStack, Textarea, Select, List, ListItem, Text, useToast
} from '@chakra-ui/react';
import axios from 'axios';
import styles from '../Tabel.module.css';
import { ACCOUNTS_URL } from '../../../../Globalapi/Globalapi';

const LedgerTable = () => {
    const [rows, setRows] = useState([
        { type: "", name: "", dr: 0, cr: 0 },
        { type: "", name: "", dr: 0, cr: 0 },
    ]);

    const [voucherNo, setVoucherNo] = useState('');
    const [date, setDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    });
    const [fromSuggestions, setFromSuggestions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [cmpId] = useState(sessionStorage.getItem('cmp_id'));
    const [narration, setNarration] = useState('');
    const toast = useToast(); // Chakra UI Toast for notifications
    const [dropdownVisibility, setDropdownVisibility] = useState({});
    const [companyData, setCompanyData] = useState(null);
    const [userId, setUserId] = useState(null);
    const [error, setError] = useState(null);
    // Fetch Voucher Number on component load
    useEffect(() => {
        const fetchVoucherNo = async () => {
            try {
                const response = await axios.post(`${ACCOUNTS_URL}/multi_voucher/voucher_number.php`, {
                    comp_id: cmpId,
                });

                if (response.data.success === true) {
                    setVoucherNo(response.data.voucher_number);
                } else {
                    console.error('Failed to fetch voucher number:', response.data.message);
                }
            } catch (error) {
                console.error('Error fetching voucher number:', error);
            }
        };

        fetchVoucherNo();
    }, [cmpId]);

    // Function to handle "Particulars" input changes and fetching suggestions
    const handleParticularsChange = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index].particulars = value;
        setRows(updatedRows);

        // Update the dropdown visibility for the specific row
        setDropdownVisibility((prevState) => ({
            ...prevState,
            [index]: value.length >= 1, // Show dropdown if input length >= 1
        }));

        if (value.length >= 1) {
            fetchFromSuggestions(value);
        }
    };

    // Fetch suggestions for "Particulars" based on input
    const fetchFromSuggestions = async (text) => {
        try {
            const response = await axios.post(`${ACCOUNTS_URL}/common/ledger_name.php`, {
                cmp_id: cmpId,
                fectxt: text
            });

            console.log('====================================');
            console.log("dsdsd",response);
            console.log('====================================');
            if (response.data.status === 'success') {
                setFromSuggestions(response.data.data);
            } else {
                setFromSuggestions([]);
            }
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            setFromSuggestions([]);
        }
    };

    // Handle the "Particulars" selection from suggestions
    const selectSuggestion = (index, suggestion) => {
        const updatedRows = [...rows];
        updatedRows[index].particulars = suggestion.L_name;
        updatedRows[index].Ldg_id = suggestion.Ldg_id;
        setRows(updatedRows);

        // Close the dropdown for the selected row
        setDropdownVisibility((prevState) => ({
            ...prevState,
            [index]: false,
        }));
    };


    const handleAddRow = () => {
      setRows([...rows, { type: "", name: "", dr: 0, cr: 0, l_id: "" }]);
    };
  
    const handleDeleteRow = (index) => {
      const updatedRows = rows.filter((_, i) => i !== index);
      setRows(updatedRows);
    };

    const handleInputChange = (index, field, value) => {
      const updatedRows = rows.map((row, i) => {
        if (i === index) {
          row[field] = value;
  
          // Reset DR and CR if type changes
          if (field === "type") {
            if (value === "By") {
              row.dr = 0;
              row.cr = 0; // Ensure CR is 0 for "By"
            } else if (value === "To") {
              row.dr = 0;
              row.cr = 0; // Ensure CR is 0 for "To" if no value is entered yet
            }
          }
        }
        return row;
      });
      setRows(updatedRows);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleAddRow();
        }
    };

    const calculateTotals = () => {
      const totalDr = rows.reduce((acc, row) => acc + (row.dr || 0), 0);
      const totalCr = rows.reduce((acc, row) => acc + (row.cr || 0), 0);
      return { totalDr, totalCr };
    };
  
    const { totalDr, totalCr } = calculateTotals();
  

    // Handle Save functionality with validation
    const handleSave = async () => {
        // Calculate total debit and credit
        const totalDebit = rows
            .filter(row => row.type === 'By')
            .reduce((acc, row) => acc + (parseFloat(row.dr) || 0), 0);

        const totalCredit = rows
            .filter(row => row.type === 'To')
            .reduce((acc, row) => acc + (parseFloat(row.cr) || 0), 0);

        // Validate if debit and credit totals match
        // if (totalDebit !== totalCredit) {
        //     const difference = Math.abs(totalDebit - totalCredit);
        //     toast({
        //         title: "Voucher Validation Failed",
        //         description: `The debit and credit totals don't match. You need to balance the transaction by ${difference}.`,
        //         status: "error",
        //         duration: 4000,
        //         isClosable: true,
        //     });
        //     return;
        // }

        try {
            // const data = rows.map(row => ({
            //     l_id: row.Ldg_id, // Use Ldg_id instead of particulars
            //     dr: row.dr || 0,
            //     cr: row.cr || 0,
            // }));

            const response = await axios.post(`${ACCOUNTS_URL}/multi_voucher/save_voucher.php`, {
                user_id: sessionStorage.getItem('user_id'), // Replace with actual user ID
                comp_id: cmpId,
                narration,
                date,
                voucher_no: voucherNo,
                data: rows.map((row) => {
                  // If row type is "By", we pass CR as 0
                  let crValue = row.cr;
                  if (row.type === "By") {
                    crValue = 0;
                  }
                  // If row type is "To", we calculate CR based on totalDr - totalCr
                  else if (row.type === "To" && row.cr === 0) {
                    crValue = totalDr - totalCr;
                  }
          
                  return {
                    l_id: row.Ldg_id || "", // Ensure l_id is passed
                    dr: row.dr,
                    cr: crValue,
                  };
                }),
            });

            console.log("Save voucher payload:", {
                user_id: sessionStorage.getItem('user_id'),
                comp_id: cmpId,
                narration,
                date,
                voucher_no: voucherNo,
                data: rows.map((row) => {
                  // If row type is "By", we pass CR as 0
                  let crValue = row.cr;
                  if (row.type === "By") {
                    crValue = 0;
                  }
                  // If row type is "To", we calculate CR based on totalDr - totalCr
                  else if (row.type === "To" && row.cr === 0) {
                    crValue = totalDr - totalCr;
                  }
          
                  return {
                    l_id: row.Ldg_id || "", // Ensure l_id is passed
                    dr: row.dr,
                    cr: crValue,
                  };
                }),
            });

            if (response.data.success) {
                toast({
                    title: "Voucher Saved",
                    description: "Voucher has been saved successfully.",
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                });
                setRows([ { type: "", name: "", dr: 0, cr: 0 }, { type: "", name: "", dr: 0, cr: 0 } ]);
                setNarration(""); // Reset narration if it's a part of the form state
            } else {
                toast({
                    title: "Save Failed",
                    description: `Failed to save voucher: ${response.data.message}`,
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                });
            }
        } catch (error) {
            console.error('Error saving voucher:', error);
        }
    };

    // Interval to check for balanced totals every 1 second
    useEffect(() => {
        const interval = setInterval(() => {
            const totalDebit = rows
                .filter(row => row.type === 'By')
                .reduce((acc, row) => acc + (parseFloat(row.dr) || 0), 0);

            const totalCredit = rows
                .filter(row => row.type === 'To')
                .reduce((acc, row) => acc + (parseFloat(row.cr) || 0), 0);

            // If totals are balanced, remove any extra "To" row
            if (totalDebit === totalCredit) {
                const toRowIndex = rows.findIndex(row => row.type === 'To' && row.cr === '' && row.dry === '');
                if (toRowIndex !== -1) {
                    const updatedRows = [...rows];
                    updatedRows.splice(toRowIndex, 1);
                    setRows(updatedRows);
                }
            }
        }, 1000);

        // Clean up the interval on component unmount
        return () => clearInterval(interval);
    }, [rows]);

    useEffect(() => {
        const storedUserId = sessionStorage.getItem('user_id');
        if (storedUserId) {
            setUserId(storedUserId);
        } else {
            setError('User not logged in or user_id not found in sessionStorage');
        }
    }, []);

    useEffect(() => {
        if (userId) {
            const fetchCompanyDetails = async () => {
                try {
                    const response = await fetch(`${ACCOUNTS_URL}/settings/company_details.php`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ user_id: userId }),
                    });

                    const data = await response.json();

                    if (data.status === 200) {
                        setCompanyData(data.data);
                    } else {
                        setError('No company found for this user.');
                    }
                } catch (err) {
                    setError('Error fetching company details.');
                }
            };

            fetchCompanyDetails();
        }
    }, [userId]); // Run when userId is set


    const printVoucher = () => {
        const printWindow = window.open('', '_blank');

        // Separate the rows based on 'By' and 'To'
        const byRows = rows.filter(row => row.type === "By");
        const toRows = rows.filter(row => row.type === "To");

        printWindow.document.write(`
            <html>
                <head>
                    <title>Voucher No: ${voucherNo}</title>
                    <style>
                        body { font-family: Arial, sans-serif; margin: 20px; }
                        h2, h4 { margin-bottom: 5px; }
                        p { margin-top: 5px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 15px; }
                        th, td { padding: 10px; text-align: left; border: 1px solid black; }
                        th { background-color: #f9f9f9; }
                        .header-info { display: flex; justify-content: space-between; margin-bottom: 20px; }
                        .total-row { font-weight: bold; }
                        .amount-text { margin-top: 10px; font-style: italic; }
                         .header {
                            text-align: center;
                            margin-bottom: 30px;
                        }
                        .header h2 { 
                            margin: 0; 
                            font-size: 22px; 
                            font-weight: bold; 
                        }
                        .header p {
                            margin: 2px 0; 
                            font-size: 14px; 
                        }
                    </style>
                </head>
                <body>
                    <div class="header">
    ${companyData.Company_Name && companyData.Company_Name.startsWith("No") === false
                ? `<h2>${companyData.Company_Name}</h2>`
                : ""}
    ${companyData.address && companyData.address.startsWith("No") === false
                ? `<p>${companyData.address}</p>`
                : ""}
    ${companyData.Tin && companyData.Tin.startsWith("No") === false
                ? `<p>GSTIN/UIN: ${companyData.Tin}</p>`
                : ""}
    ${companyData.Email_Id && companyData.Email_Id.startsWith("No") === false
                ? `<p>Email: ${companyData.Email_Id}</p>`
                : ""}
</div>
                    <div class="header-info">
                        <div>
                            <h4>TO:   ${toRows.map(row => row.particulars).join(', ')}</h4>
                        </div>
                        <div>
                            <p>No: ${voucherNo}</p>
                            <p>Date: ${date}</p>
                        </div>
                    </div>
    
                    <table>
                        <thead>
                            <tr>
                                <th>Sl No.</th>
                                <th>Description</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                         ${byRows.map((row, index) => `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${row.particulars}</td>
                                <td>${row.dr}</td>
                            </tr>
                        `).join('')}
                    </table>
    
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.print();
    };


    return (
        <Box borderRadius='20px' background='white' mx="auto">
            <Flex justifyContent="space-between" mb="4" p="20px">
                <FormControl maxW="20%">
                    <FormLabel>Voucher No</FormLabel>
                    <Input value={voucherNo} readOnly placeholder="Voucher No" />
                </FormControl>
                <FormControl maxW="20%">
                    <FormLabel>Date</FormLabel>
                    <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
                </FormControl>
            </Flex>

            <Box minHeight='400px' style={{ overflowX: 'auto' }} width="100%" className={styles.Table}>
                <Table mb="4">
                    <Thead>
                        <Tr>
                            <Th textAlign='left' textTransform='initial'>By/To</Th>
                            <Th textAlign='left' textTransform='initial'>Particulars</Th>
                            <Th textAlign='right' textTransform='initial'>Credit</Th>
                            <Th textAlign='right' textTransform='initial'>Debit</Th>
                            <Th textAlign='center'>Actions</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {rows.map((row, index) => (
                            <Tr key={index}>
                                <Td>
                                    <Select
                                        value={row.type}
                                        onChange={(e) =>
                                            handleInputChange(index, "type", e.target.value)
                                        }
                                    >
                                        <option value="">Select</option>
                                        <option value="By">By</option>
                                        <option value="To">To</option>
                                    </Select>
                                </Td>
                                <Td position="relative">
                                    <Input
                                        value={row.particulars}
                                        onChange={(e) => handleParticularsChange(index, e.target.value)}
                                        placeholder="Enter Particulars"
                                    />
                                    {dropdownVisibility[index] && fromSuggestions.length > 0 && (
                                        <Box
                                            border="1px solid #ccc"
                                            borderRadius="md"
                                            mt={1}
                                            maxH="150px"
                                            overflowY="auto"
                                            bg="white"
                                            zIndex={1}
                                            position="absolute"
                                            w="100%"
                                        >
                                            <List spacing={0}>
                                                {fromSuggestions.map((suggestion) => (
                                                    <ListItem
                                                        key={suggestion.Ldg_id}
                                                        p={2}
                                                        _hover={{ backgroundColor: 'gray.100', cursor: 'pointer' }}
                                                        onClick={() => selectSuggestion(index, suggestion)}
                                                    >
                                                        {suggestion.L_name}
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Box>
                                    )}
                                    {dropdownVisibility[index] && fromSuggestions.length === 0 && (
                                        <Text p={2}>No suggestions found</Text>
                                    )}
                                </Td>

                                <Td>
                                    <Input
                                        type="number"
                                        value={
                                            row.type === "By" && row.dr === 0
                                                ? Math.max(totalCr - totalDr, 0) // Ensure DR value never goes negative
                                                : row.dr
                                        }
                                        isReadOnly={row.type === "To"} // Disables input when "To" is selected
                                        onChange={(e) =>
                                            handleInputChange(index, "dr", Math.max(parseFloat(e.target.value), 0)) // Ensure no negative DR input
                                        }
                                        onKeyDown={handleKeyDown}
                                    />
                                </Td>
                                <Td>
                                    <Input
                                        type="number"
                                        value={
                                            row.type === "To" && row.cr === 0
                                                ? Math.max(totalDr - totalCr, 0) // Ensure CR value never goes negative
                                                : row.cr
                                        }
                                        isReadOnly={row.type === "By"} // Disables input when "By" is selected
                                        onChange={(e) => {
                                            const newValue = Math.max(parseFloat(e.target.value), 0);
                                            console.log({
                                                index,
                                                fieldType: "cr",
                                                newValue,
                                                totalDr,
                                                totalCr,
                                                rowType: row.type,
                                                rowCr: row.cr,
                                            }); // Logs relevant information for debugging
                                            handleInputChange(index, "cr", newValue); // Ensure no negative CR input
                                        }}
                                        onKeyDown={handleKeyDown}
                                    />
                                </Td>

                                <Td>
                                    <Button
                                        colorScheme="red"
                                        onClick={() => handleDeleteRow(index)}
                                    >
                                        Delete
                                    </Button>
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Box>
            <Box p={5}>
                <Textarea
                    mt={4}
                    placeholder="Narration"
                    value={narration}
                    onChange={(e) => setNarration(e.target.value)}
                />
            </Box>
            <Box p={5}>

                <Button bg='#ff8f00' color='white' mt={4} onClick={handleSave}>Save</Button>
                <Button bg='#4CAF50' color='white' mt={4} ml={2} onClick={() => {
                    handleSave();
                    printVoucher();
                }}>Print</Button>
            </Box>

        </Box>
    );
};

export default LedgerTable;
